<template>
  <div style="text-align: left; font-size: 0.24rem">
    <ul class="enable-list-type">
      <li>此地址<span style="color: #ff5455">只可入金1笔, 如重复使用, 将会失去资金（不作补偿）</span> </li>
      <li>存款必须使用{{ `${payCurrency.substring(0,4)}-${payCurrency.substring(4,payCurrency.length)}` }}的方式入金， 请留意您使用的<span style="color: #ff5455">链类型是否正确，否则资金将会遗失（不作补偿）</span>  </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'IPayAlert',
  props: ['payCurrency']
}
</script>
